export default {
  namespaced: true,
  state: {
    error401: "https://shopcenter.xkw.com/error/error401.html",
    error404: "https://shopcenter.xkw.com/error/error404.html",
  },
};
